import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";

export default function ImpersonatePage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = searchParams.get("token");
    if (!token) {
      setError("No impersonation token provided");
      return;
    }

    // Store the impersonation token in sessionStorage (tab-isolated)
    sessionStorage.setItem("impersonate_token", token);
    sessionStorage.setItem("impersonate_active", "true");

    // Redirect to the user's inbox
    navigate("/inbox", { replace: true });
  }, [searchParams, navigate]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F5F5F5]">
        <div className="text-center space-y-2">
          <p className="text-sm text-red-600 font-medium">{error}</p>
          <button onClick={() => window.close()} className="text-xs text-zinc-500 underline">Close this tab</button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F5F5F5]">
      <div className="flex items-center gap-2 text-zinc-500">
        <Loader2 size={16} className="animate-spin" />
        <span className="text-sm">Loading user session...</span>
      </div>
    </div>
  );
}
